import PropTypes from 'prop-types';

import { Colors } from '@spotahome/ui-library';

import './MobileIllustration.scss';

const MobileIllustration = ({ className = '' }) => {
  return (
    <svg className={className} viewBox="0 0 500 500">
      <defs>
        <clipPath id="clip0_1_15">
          <rect fill="white" height="500" rx="24" width="500" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip0_1_15)">
        <rect
          fill={Colors['secondary-pink']}
          height="500"
          rx="24"
          width="500"
        />

        <g className="phone-vibration">
          <rect fill="#F4EFED" height="132" width="344" x="78" y="320" />
          <rect
            fill={Colors.interaction}
            height="446"
            width="343"
            x="78"
            y="-126"
          />
          <circle cx="248.784" cy="385.642" fill="white" r="38.5643" />
        </g>
      </g>
    </svg>
  );
};

MobileIllustration.propTypes = {
  className: PropTypes.string
};

export default MobileIllustration;
